__turbopack_context__.v({
  "Video": "Video-module-sass-module__XSq0gW__Video",
  "VideoContent": "Video-module-sass-module__XSq0gW__VideoContent",
  "VideoCopy": "Video-module-sass-module__XSq0gW__VideoCopy",
  "VideoPoster": "Video-module-sass-module__XSq0gW__VideoPoster",
  "VideoTitles": "Video-module-sass-module__XSq0gW__VideoTitles",
});
